import { useMemo } from 'react'

import { useTreeContext } from './treeContext'
import { TreeNode } from './TreeNode'

export const TreeContent = () => {
  const { trees, shouldSortNodes } = useTreeContext()
  const unGroupedNode = trees.find((node) => !node.name)
  const sortedTrees = useMemo(
    () =>
      shouldSortNodes
        ? [...trees].sort((a, b) =>
            a.name.localeCompare(b.name, undefined, {
              sensitivity: 'base',
            }),
          )
        : trees,
    [trees, shouldSortNodes],
  )

  return (
    <div>
      {unGroupedNode ? (
        <TreeNode
          key={unGroupedNode?.path.join('.') ?? 'ungrouped'}
          node={unGroupedNode}
        />
      ) : null}
      {sortedTrees
        .filter((node) => node !== unGroupedNode)
        .map((treeNode) => (
          <TreeNode key={treeNode.path.join('.')} node={treeNode} />
        ))}
    </div>
  )
}
